export const user = require('./user').default;
export const base = require('./base').default;
export const hallControl = require('./hallControl').default;